<template>
    <div>
        <div class="app-title">
            <em-view-title ref="viewTitle" :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                           :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                           $_em-custom-vuex-mixin_vo="exportVoVo"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"
                                           @showEntityMultipleModalSelect="$_emCommonModalMixin_showMultipleSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesPrdProjectKamResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"
                                      :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                      :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                      $_em-custom-vuex-mixin_vo="exportVoVo"
                                      ref="emTable" :inlineActionsDisabled="prop_inline!=='1'"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow"
                                      header-btn-add-disabled header-btn-edit-disabled
                                      enable-field-batch-edit
                                      accept-batch-edit-fields="remark"
                                      with-custom-row-actions
                                      with-custom-row-actions-first-column>
                                <template slot="left-header">
                                    <b-button-group>
                                        <em-button type="edit"
                                                   :disabled="$_notChecked"
                                                   custom-label="设置要求时间偏移量"
                                                   showName
                                                   v-bind:class="'btn btn-outline-primary btn-sm'"
                                                   @click="openSetTimeOffset()">
                                        </em-button>
                                        <em-button type="edit"
                                                   :disabled="$_notCheckedOne"
                                                   custom-label="设置当前需求时间"
                                                   custom-icon="fa fa-regular fa-clock"
                                                   v-bind:class="'btn btn-outline-primary btn-sm'"
                                                   :busy="setDeadlineLoading"
                                                   @click="openDeadlineSetModal()">
                                        </em-button>
                                        <em-button type="edit" custom-icon="fa fa-fw fa-lg fa-list-alt"
                                                   :disabled="$_notCheckedOne"
                                                   custom-label="KAM行编辑"
                                                   showName
                                                   v-bind:class="'btn btn-outline-primary btn-sm'"
                                                   @click="gotoKamSelection()">
                                        </em-button>
                                        <em-button type="search"
                                                   custom-icon="fa fa-solid fa-lock"
                                                   :disabled="$_notChecked"
                                                   :busy="lockLoading"
                                                   custom-label="锁定"
                                                   class="btn btn-outline-primary btn-sm"
                                                   @click="changeProjectKamLockStatus('lock')">
                                        </em-button>
                                        <em-button type="search"
                                                   custom-icon="fa fa-solid fa-lock-open"
                                                   :disabled="$_notChecked"
                                                   :busy="lockLoading"
                                                   custom-label="解锁"
                                                   class="btn btn-outline-primary btn-sm"
                                                   @click="changeProjectKamLockStatus('unlock')">
                                        </em-button>
                                        <em-button type="search"
                                                   :disabled="$_notChecked || isSettingCritical == null"
                                                   :busy="setCriteriaLoading"
                                                   :custom-label="isSettingCritical===false?'取消关键部件':'关键部件'"
                                                   show-name
                                                   class="btn btn-outline-primary btn-sm"
                                                   @click="setCritical()">
                                        </em-button>
                                        <mini-button :disable="$_notChecked"
                                                     :loading="reCompareLoading"
                                                     @click="reCompare">
                                            <i class="fa-solid fa-snowflake"></i>
                                            Reload
                                        </mini-button>
                                    </b-button-group>
                                </template>
                                <template slot="customRowActionsFirstColumn" slot-scope="{row}">
                                    <b-button-group>
                                        <em-button v-if="row.sapAssignStatus === 2"
                                                   type="task"
                                                   :busy="reassignLoading"
                                                   class="btn btn-outline-primary btn-sm"
                                                   custom-icon="fa fa-solid fa-code-pull-request"
                                                   custom-label="重新上挂"
                                                   @click="reassignMaterial(row.id)">
                                        </em-button>
                                    </b-button-group>
                                </template>
                                <template #customRowActions="{row}">
                                    <overlay-mini-table entity-name="sithMesPrdInfoRecord"
                                                        custom-vuex-name="subview"
                                                        click-trigger lazy-load
                                                        title="test"
                                                        btn-variant="outline-primary"
                                                        btn-icon="fa fa-solid fa-ellipsis-vertical"
                                                        :data="{}"
                                                        :query-api="getQueryApi(row.id)">
                                    </overlay-mini-table>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
        <!-- 设置要求时间偏移 -->
        <el-dialog title="设置要求时间偏移量" :visible.sync="offsetDialogVisible" :close-on-click-modal='false'
                   append-to-body
                   @close='clearOffset'>
            <el-form :model="offsetForm" ref="offsetForm" label-width="auto" style="width:35%;margin-top:15px;"
                     :rules="rules">
                <el-form-item style="width: max-content;" label="要求时间偏移量(天)" prop="offset">
                    <el-input v-model="offsetForm.offset" type="number" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="offsetDialogVisible = false">取 消</el-button>
                <el-button type="primary" :loading="dateOffsetLoading" @click="setTimeOffset()">确认</el-button>
            </div>
        </el-dialog>
        <re-b-modal ref="setDeadlineModal" header="设置当前需求时间" @ok="setDeadline">
            <diverse-input :value.sync="deadlineDate" :config="inputConfig" horizontal></diverse-input>
            <div style="height: 320px"></div>
        </re-b-modal>
    </div>
</template>
<script>
// Author Liang Gang Qiang
// Date 2022-10-31 14:14:27

import emCommonListMixin from "@/mixin/em/common/list";
import emCustomVuexMixin from "@/mixin/em/customVuex";
import EmCommonApi from "@/mixin/em/common/api";
import emTableCheckedMixin from "@/mixin/em/common/stuffs/table/emTableCheckedMixin";
import OverlayMiniTable from "@/components/workflow/stuffs/OverlayMiniTable";
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal.vue";
import DiverseInput from "@/components/workflow/stuffs/DiverseInput.vue";
import MiniButton from "@/components/common/buttons/MiniButton.vue";

export default {
    name: "sithMesPrdProjectKamListView",
    components: {MiniButton, DiverseInput, ReBModal, OverlayMiniTable},
    mixins: [emCommonListMixin, EmCommonApi, emCustomVuexMixin, emTableCheckedMixin],
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        },
        $_customVuexName() {
            return 'exportVo'
        },
        isSettingCritical() {
            if (this.$_checked) {
                let flag = null;
                for (const row of this.checkedRows) {
                    let critical = row.isCritical;
                    if (critical !== undefined && critical != null) {
                        if (flag == null) {
                            flag = critical;
                        } else if (critical !== flag) {
                            return null;
                        }
                    }
                }
                return flag !== true;
            }
            return null;
        },
    },
    data() {
        return {
            offsetDialogVisible: false,
            offsetForm: {
                offset: ''
            },
            rules: {
                offset: [{required: true, message: '请输入要求时间偏移量'}]
            },
            reassignLoading: false,
            lockLoading: false,
            dateOffsetLoading: false,

            deadlineDate: '',
            selectId: '',
            inputConfig: {
                type: 'datetime',
                label: '当前需求时间'
            },
            setDeadlineLoading: false,

            setCriteriaLoading: false,
            reCompareLoading: false,
        }
    },
    methods: {
        popSpa(row) {
            this.$refs.spaEntityList.showModal(row.id);
        },
        openSetTimeOffset() {
            if (this.$_checkedOne && this.checkedRows[0].timeOffset) {
                this.offsetForm.offset = this.checkedRows[0].timeOffset;
            }
            this.offsetDialogVisible = true;
        },
        clearOffset() {
            this.offsetForm.offset = '';
            this.$refs['offsetForm'].resetFields();
        },
        setTimeOffset() {
            let self = this;
            let url = `${this.$_emApiMixin_entityBaseApi("sithMesPrdProjectKam")}/setTimeOffset?ids=${this.selectIds}&offset=${self.offsetForm.offset}`;
            self.$refs['offsetForm'].validate((valid) => {
                if (valid) {
                    this.dateOffsetLoading = true;
                    self.$_emApiMixin_post(url, {})
                        .then((request) => {
                            if (request.status === 200) {
                                self.$message({
                                    message: "设置成功",
                                    type: "success",
                                });

                                self.$refs.emListFilter.doQuery();
                            } else {
                                self.$message({
                                    message: "设置失败",
                                    type: "error",
                                });
                            }
                        }).finally(() => {
                        this.dateOffsetLoading = false;
                        this.offsetDialogVisible = false;
                    })
                }
            });
        },
        reassignMaterial(id) {
            this.reassignLoading = true;
            this.$store.dispatch('api/post', {
                url: process.env.VUE_APP_SITHMES_PRD_URL + "/sithMesPrdProjectKam/reassign?processId=" + id,
                data: {}
            }).then(() => this.$message.success('reassign success'))
                .finally(() => this.reassignLoading = false);
        },
        gotoKamSelection() {
            let projectCode = this.checkedRows[0].projectCode;
            let projectName = this.checkedRows[0].projectName;
            this.$router.push("/sithMes/prd/sithMesPrdProjectKamSelection?projectCode=" + projectCode + "&projectName=" + projectName);
        },
        changeProjectKamLockStatus(toStatus) {
            if (this.$_checked) {
                this.lockLoading = true;
                this.$store.dispatch('api/post', {
                    url: process.env.VUE_APP_SITHMES_PRD_URL + "/sithMesPrdProjectKam/" + toStatus + "?projectKamIds=" + this.selectIds,
                    data: {}
                }).then(() => {
                    this.$message.success(toStatus + " success");
                    this.$refs.emListFilter.doQuery();
                }).finally(() => this.lockLoading = false);
            }
        },
        getQueryApi(id) {
            return process.env.VUE_APP_SITHMES_PRD_URL + "/sithMesPrdProjectKam/queryEditRecord?id=" + id;
        },
        openDeadlineSetModal() {
            if (this.$_checkedOne) {
                let row = this.checkedRows[0];
                this.selectId = row.id;
                this.deadlineDate = row.kamDeadline;
                this.$refs.setDeadlineModal.showModal();
            }
        },
        setDeadline() {
            if (this.selectId && this.deadlineDate) {
                this.setDeadlineLoading = true;
                this.$store.dispatch('api/post', {
                    url: process.env.VUE_APP_SITHMES_PRD_URL + "/sithMesPrdProjectKam/setDeadline",
                    data: {
                        id: this.selectId,
                        deadline: this.deadlineDate
                    }
                }).then(() => {
                    this.$message.success("修改成功");
                    this.$refs.emListFilter.doQuery();
                }).finally(() => this.setDeadlineLoading = false);
            }
        },

        setCritical() {
            if (this.$_checked) {
                this.setCriteriaLoading = true;
                this.$store.dispatch('api/post', {
                    url: `${process.env.VUE_APP_SITHMES_PRD_URL}/sithMesPrdProjectKam/${this.isSettingCritical ? 'set' : 'clear'}Critical`,
                    data: this.checkedItems
                }).then(() => {
                    this.$message.success("修改成功");
                    this.$refs.emListFilter.doQuery();
                }).finally(() => this.setCriteriaLoading = false);
            }
        },
        reCompare() {
            if (this.$_checked) {
                this.reCompareLoading = true;
                this.$store.dispatch('api/post', {
                    url: `${process.env.VUE_APP_SITHMES_PRD_URL}/sithMesPrdProjectKam/reCompare`,
                    data: this.checkedItems
                }).then(() => {
                    this.$message.success("Reload Success");
                    this.$refs.emListFilter.doQuery();
                }).finally(() => this.reCompareLoading = false);
            }
        },
    },
    mounted() {
        if (this.$route.query.hasOwnProperty('processId')) {
            this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('idFilter', this.$route.query.processId);
            this.$refs.emListFilter.doQuery();
        }
    },
};
</script>
